module.exports = __webpack_public_path__ + "static/background_lake_wbottle-4cfe5052ac39284adbb5d3ca957ee96a.jpg";